<template>
<!--  ADJUST HEIGHT IF SUBTITLES ARE ENABLED-->
  <div :style="{'height': this.showSubtitles && this.type==='audio' ? 'calc('+maxHeight+' + 150px)' : maxHeight, 'width': maxWidth}" style="transition: 0.2s;">
<!--  <div :style="'height: '+maxHeight+'; width: '+maxWidth+''" >-->
<!--    <transition name="slide-x-transition">-->
    <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center" v-if="loading">
      <v-progress-circular
          v-if="loading"
          :size="50"
          color="white"
          indeterminate
          width="1"
      ></v-progress-circular>
    </div>
<!--    </transition>-->
    <transition name="slide-x-transition" >
      <MediaCompositionAudio
          ref="audio"
          v-if="type==='audio' && shouldRender"
          v-show="mediaReady && !loading"
          :id="id"
          :volume="volume / 100"
          :url="audio"
          :subtitles="subtitles"
          :events="events"
          :show-subtitles="showSubtitles"
          :autoplay="autoplay"
          :on-progress="setCurrentTime"
          :parent-height="maxHeight"
          @reset="reset($event)"
          @complete="complete($event)"
          @event="event($event)"
          @mediaReady="setMediaReady($event)"
          @play="play()"
          @pause="pause()"
          @hideControls="showControls = false"
          @showControls="showControls = true"
      ></MediaCompositionAudio>
    </transition>

    <transition>
      <MediaCompositionAnimation
          ref="animation"
          v-if="type==='animation' && shouldRender"
          v-show="mediaReady && !loading"
          :id="id"
          :json="json"
          :sounds="sounds"
          :narration="audio"
          :volume="volume / 100"
          :subtitles="subtitles"
          :events="events"
          :show-subtitles="showSubtitles"
          :autoplay="autoplay"
          :on-progress="setCurrentTime"
          @reset="reset($event)"
          @complete="complete($event)"
          @event="event($event)"
          @mediaReady="setMediaReady($event)"
          @play="play()"
          @pause="pause()"
          @hideControls="showControls = false"
          @showControls="showControls = true"
      ></MediaCompositionAnimation>
    </transition>

    <transition>
      <MediaCompositionVideo
          ref="video"
          v-if="type==='video' && shouldRender"
          v-show="mediaReady && !loading"
          :id="id" :video="video"
          :volume="volume / 100"
          :subtitles="subtitles"
          :events="events"
          :show-subtitles="showSubtitles"
          :autoplay="autoplay"
          :on-progress="setCurrentTime"
          @reset="reset($event)"
          @complete="complete($event)"
          @event="event($event)"
          @mediaReady="setMediaReady($event)"
          @play="play()"
          @pause="pause()"
          @hideControls="showControls = false"
          @showControls="showControls = true"
      ></MediaCompositionVideo>
    </transition>

    <MediaEvents
        ref="mediaEvent"
        :subtitles="subtitles"
        :events="events"
        :show-subtitles="showSubtitles"
        @eventStarted="triggerEvent('eventStarted',$event)"
        @eventEnded="triggerEvent('eventEnded',$event)"
        @endAllEvents="triggerEvent('endAllEvents',$event)"
        v-show="mediaReady"
        v-if="renderEventComponent"
        :type="type==='audio' ? 'scrolling' : 'black-bar'"
    ></MediaEvents>

    <transition name="slide-x-transition">
      <MediaCompositionControls
          ref="controls"
          v-if="controls && shouldRender"
          v-show="showControls && mediaReady && !loading"
          :show-subtitles="showSubtitles"
          :show-transcription="showTranscription"
          :subtitles-available="subtitles != null && subtitles.length > 0"
          :transcription-available="transcription != null && transcription.length > 0"
          :media-ready="mediaReady"
          :is-playing="isPlaying"
          @reset="reset()"
          @backward="backward()"
          @togglePlayPause="togglePlayPause()"
          @forward="forward()"
          @toggleSubtitles="setSubtitles(!showSubtitles)"
          @setVolume="setVolume($event)"
      ></MediaCompositionControls>
    </transition>

  </div>
</template>

<script>
  import MediaCompositionVideo from "./video/MediaCompositionVideo";
  import MediaCompositionAnimation from "./animation/MediaCompositionAnimation";
  import MediaCompositionAudio from "./audio/MediaCompositionAudioMotion";
  //import MediaCompositionAudio from "./audio/MediaCompositionAudioHowler";
  //import MediaCompositionAudio from "./audio/MediaCompositionAudio";
  import MediaCompositionControls from "./controls/MediaCompositionControls";
  import MediaEvents from "./event/MediaEvents";


  export default {
    name: "MediaComposition",
    components: {
      MediaCompositionAnimation,
      MediaCompositionVideo,
      MediaCompositionAudio,
      MediaCompositionControls,
      MediaEvents,
    },
    data() {
      return {
        isPlaying: false,
        volume: 0,
        showSubtitles: false,
        showControls: true,
        showTranscription: false,
        mediaReady: false,
        currentTime: 0,
        loading: true,
        type: null,
        shouldRender:false,
        renderEventComponent:false,
      }
    },
    props: {
      delay : {
        default : null
      },
      mediaComposition: {
        type: Object,
        required: true
      },
      controls: {
        default: true,
        type: Boolean
      },
      loop: {
        default: false,
        type: Boolean
      },
      autoplay: {
        default: false,
        type: Boolean
      },
      maxHeight: {
        type: String,
        default: '100%',
      },
      maxWidth: {
        type: String,
        default: '100%',
      },
      subtitlesDefault: {
        default: false,
      }
    },
    computed: {
      id() {
        if (!this.mediaComposition) return;
        return this.mediaComposition.mediacompositionid;
      },
      sounds() {
        if (!this.mediaComposition) return;

        return this.$asset(this.mediaComposition.sound_assetid);
      },
      video() {
        if (!this.mediaComposition) return;

        return this.$asset(this.mediaComposition.video_assetid);
      },
      json() {
        if (!this.mediaComposition) return;

        return this.$asset(this.mediaComposition.json_assetid);
      },
      audio() {
        if (!this.mediaComposition) return;

        return this.$asset(this.mediaComposition.voice_assetid);
      },
      subtitles() {
        if (!this.mediaComposition) return;
        if (!this.mediaComposition.subtitles) return [];

        return this.mediaComposition.subtitles.map((subtitle)=>{
          return {
            start:subtitle.from,
            end:subtitle.to,
            text: this.$ta(subtitle.content_textassetid)
          }
        });
      },
      transcription() {
        if (!this.mediaComposition) return;
        return this.mediaComposition.transcription || [];
      },
      events() {
        if (!this.mediaComposition) return;
        if (!this.mediaComposition.events) return [];

        return this.mediaComposition.events.map((event)=>{
          return {
            start : event.start_time,
            end : event.end_time,
            eventstring : event.eventname,
          }
        });
      },
    },
    methods: {
      triggerEvent(event_type,data){
        this.$emit(event_type,data);
      },
      togglePlayPause() {
        if (!this.isPlaying) {
          this.play();
        } else {
          this.pause();
        }
      },
      setMediaReady(duration) {

        this.duration = duration;

        //The timeouts are used for transitions
        //sodat die sisteem nie vol krieke is nie
        setTimeout(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        }, 200);

        setTimeout(() => {
          // this.$nextTick(() => {
            this.$nextTick(() => {
              this.mediaReady = true;

              this.$emit('mediaReady');
            });

          // });
        }, 800);

        if (this.autoplay) {
          this.play();
        }

      },
      setCurrentTime(time) {
        this._currentTime = time;
      },
      play() {
        this.isPlaying = true;
        this.$refs[this.type].play();
        this.startTrackingMediaEvents('play');
        this.startSettingProgress();
        this.$emit('play');

        if(this.$store.state.media.subtitlesActive){
          this.showSubtitles=true;
        }
      },
      pause() {
        this.isPlaying = false;
        this.$refs[this.type].pause();
        this.stopTrackingMediaEvents('pause');
        this.$emit('pause');
      },
      forward(time = 5) {
        this.stopTrackingMediaEvents();
        this.$refs[this.type].forward(time);
        this.startTrackingMediaEvents('skip');

        let progress = 0;

        if (!isNaN(this._currentTime) && !isNaN(this.duration) && this._currentTime > 0 && this.duration > 0)
          progress = (this._currentTime / this.duration) * 100;

        this.setProgress(progress);
      },
      backward(time = 5) {
        this.stopTrackingMediaEvents();
        this.$refs[this.type].backward(time);
        this.startTrackingMediaEvents('skip');

        let progress = 0;

        if (!isNaN(this._currentTime) && !isNaN(this.duration) && this._currentTime > 0 && this.duration > 0)
          progress = (this._currentTime / this.duration) * 100;

        this.setProgress(progress);

      },
      setVolume(vol = 80) {
        this.volume = vol;
      },
      setSubtitles(show) {
        this.showSubtitles = show;

        //Scroll subtitles to correct place for audio when expanding subtitles
        if(show && this.type === 'audio'){
          setTimeout(()=>{
            if(!this.$refs.mediaEvent){
              return;
            }
            this.$refs.mediaEvent.setCurrentTime(this._currentTime, 'set-subtitles');
          },250);
        }
      },
      setProgress(progress) {
        if (this.controls) {
          this.$refs.controls.setProgress(progress);
        } else {
          this.$emit('progress', progress);
        }
      },
      reset() {
        this.$refs[this.type].reset();

        if (this.isPlaying) {
          setTimeout(() => {
            this.$refs[this.type].play();
            this.$emit('play');
          }, 400);

        } else if (this.isPlaying && this.loop) {

          setTimeout(() => {
            this.$refs[this.type].play();
            this.$emit('play');
            this.isPlaying = true;
            this.startSettingProgress();
          }, 400);

        } else {

          if (!this.autoplay) {
            this.showControls = false;

            //For transitions
            setTimeout(() => {
              this.$refs[this.type].showOverlay = true;
            }, 400);

          }

          // this.$store.dispatch('media/setSubtitles',false);
          this.showSubtitles = false;

          //If in paused state, fill the controls progress
          this.setProgress(100);
        }
      },
      complete(id) {
        //Do not stop playing if loop is enabled, just continue playing but from the start
        if (!this.loop)
          this.isPlaying = false;

        this.$emit('mediaComplete', id);
        this.reset();
      },
      event(event) {
        this.$emit('mediaEvent', event);
      },
      startTrackingMediaEvents(event) {
        if (!this.$refs.mediaEvent) return;

        //Failsafe not to start multiple threads of media events tracking
        this.stopTrackingMediaEvents();

        this.$refs.mediaEvent.setCurrentTime(this._currentTime, event);

        this._mediaEventsInterval = setInterval(() => {
          if (!this.isPlaying) this.stopTrackingMediaEvents();
          else {
            this.$refs.mediaEvent.setCurrentTime(this._currentTime);
          }
        }, 50);
      },
      stopTrackingMediaEvents(event) {
        if (this.$refs.mediaEvent != null)
          this.$refs.mediaEvent.setCurrentTime(this._currentTime, event);

        clearInterval(this._mediaEventsInterval);
        this._mediaEventsInterval = null;
      },
      startSettingProgress() { //atm only used for component-specific controls progress (not framework)
        //Failsafe not to start multiple threads of setting progress
        this.stopSettingProgress();

        this._progressInterval = setInterval(() => {
          if (!this.isPlaying) this.stopSettingProgress(); //no need to update if paused
          else {
            let progress = 0;

            if (!isNaN(this._currentTime) && !isNaN(this.duration) && this._currentTime > 0 && this.duration > 0)
              progress = (this._currentTime / this.duration) * 100;

            this.setProgress(progress);
          }
        }, 800);
      },
      stopSettingProgress() {
        clearInterval(this._progressInterval);
        this._progressInterval = null;
      },
      getCurrentTime(){
        return this._currentTime;
      }
    },
    beforeDestroy() {
      this.stopTrackingMediaEvents();
      this.stopSettingProgress();
    },
    created(){
      if(!this.delay) {
        this.shouldRender = true;
      }else{
        setTimeout(()=>{
          this.shouldRender=true;
        },this.delay)
      }
    },
    mounted() {

      //Initiate default values if the component should have its own controls
      if (this.controls) {
        this.volume = 80;
        this.showSubtitles = false;

        if (!this.autoplay) //hide the controls so that the overlay play button can show on the element
          this.showControls = false;
      }

      this._currentTime = 0; //it is *not* unused, don't listen to the IDE

      if (this.mediaComposition){
        this.type = this.mediaComposition.composition_type;
        this.renderEventComponent = true;

        if(this.subtitlesDefault || this.subtitlesDefault == 1) {
          this.setSubtitles(true);

          this.$store.dispatch('media/setSubtitles',true);
        }else if(!this.subtitlesDefault || this.subtitlesDefault == 0) {
          this.setSubtitles(false);

          this.$store.dispatch('media/setSubtitles',false);
        }
      }


    }
  }
</script>

<style scoped>
  .center {
    position: relative;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -90%);
  }
</style>
